module.exports = __webpack_public_path__ + "static/media/adnan.ce1faa09.jpg";